import { useState } from "react";
import { Tabs } from "antd";
import Overview from "./Overview";
import Odometer from "./Odometer";
import Trips from "./Trips";
// import Charging from "./Charging";
import VehicleUsage from "./VehicleUsage";
import DataAvailability from "./DataAvailability";
import { useSelector } from "react-redux";

const Analytics = ({
  selectedDateRange,
  datePickerType,
  pickerOptionChange,
}) => {
  const [selectedTab, setSelectedTab] = useState("overview");
  const vehicleDetails = useSelector((state) => state.eol?.vehicleDetails);

  const onChangeTab = (tab) => {
    setSelectedTab(tab);
    if (tab === "overview") {
      pickerOptionChange([]);
    } else if (tab === "dataAvailability") {
      pickerOptionChange(["day", "month"]);
    } else {
      pickerOptionChange(["day", "week", "month"]);
    }
  };

  const tabItems = [
    {
      label: "Overview",
      key: "overview",
      children: <Overview selectedTab={selectedTab} />,
    },
    {
      label: "Odometer",
      key: "odometer",
      children: (
        <Odometer
          selectedTab={selectedTab}
          selectedDateRange={selectedDateRange}
          datePickerType={datePickerType}
          vehicleDetails={vehicleDetails}
        />
      ),
    },
    {
      label: "Trips",
      key: "trips",
      children: (
        <Trips
          selectedTab={selectedTab}
          selectedDateRange={selectedDateRange}
          datePickerType={datePickerType}
        />
      ),
    },
    // {
    //   label: "Charging",
    //   key: "charging",
    //   children: (
    //     <Charging
    //       selectedTab={selectedTab}
    //       selectedDateRange={selectedDateRange}
    //       datePickerType={datePickerType}
    //     />
    //   ),
    // },
    // {
    //   label: "Vehicle Usage",
    //   key: "usage",
    //   children: (
    //     <VehicleUsage
    //       selectedDateRange={selectedDateRange}
    //       datePickerType={datePickerType}
    //       vehicleDetails={vehicleDetails}
    //     />
    //   ),
    // },
    {
      label: "Data Availability",
      key: "dataAvailability",
      children: (
        <DataAvailability
          selectedDateRange={selectedDateRange}
          datePickerType={datePickerType}
          vehicleDetails={vehicleDetails}
        />
      ),
    },
  ];

  return (
    <>
      <Tabs
        items={tabItems}
        defaultActiveKey="overview"
        onChange={onChangeTab}
      />
    </>
  );
};

export default Analytics;
